export default {
  label: {
    display: 'block',
    fontSize: '16px',
    lineHeight: 1,
    padding: '5px 0 10px 0',
  },
}
